/**
 * TMR Unique Resource Value directive: checks that the value entered is unique.
 * Used by tmr-unique-resource-value (resource) and tmr-unique-resource-value-field (resource field to check) components.
 *
 * @namespace
 * @alias tmrUniqueResourceValue
 * @type {ngDirective}
 */
function tmrUniqueResourceValueDirective($parse) {
  'ngInject'
  return {
    require: 'ngModel',
    link,
  }

  function link(scope, elm, attrs, ctrl) {
    if (attrs.tmrUniqueResourceValueField === undefined) {
      throw new Error(
        'tmrUniqueResourceValue directive requires a tmrUniqueResourceValueField attribute'
      )
    }

    ctrl.$asyncValidators.tmrUniqueResourceValue = tmrUniqueResourceValue
    let resourceFn = $parse(attrs.tmrUniqueResourceValue) // Resource
    let fieldFn = $parse(attrs.tmrUniqueResourceValueField) // Field to check
    let originalValue // Original value of the resource's field

    function tmrUniqueResourceValue(modelValue) {
      let resource = resourceFn(scope)
      let field = fieldFn(scope)

      // init origial resource value
      originalValue = originalValue ?? resource[field]

      // Check if the modelValue is equal to orignal value
      if (
        resource === undefined ||
        modelValue === undefined ||
        originalValue == modelValue
      ) {
        return Promise.resolve(true)
      }
      // Check if the value is unique
      return resource
        .$count({ [field]: modelValue })
        .then(count => (count ? Promise.reject() : true))
    }
  }
}

export const directive = [
  'tmrUniqueResourceValue',
  tmrUniqueResourceValueDirective,
]
